var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChooseVideoVerificationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 7,
    fill: "url(#paint0_linear_11837_2934)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(3 3)",
    fill: "url(#paint1_linear_11837_2934)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.83 8H23C24.1 8 25 8.9 25 10V22C25 23.1 24.1 24 23 24H7C5.9 24 5 23.1 5 22V10C5 8.9 5.9 8 7 8H10.17L12 6H18L19.83 8ZM7 22H23V10H18.95L17.12 8H12.88L11.05 10H7V22ZM15 11C12.24 11 10 13.24 10 16C10 18.76 12.24 21 15 21C17.76 21 20 18.76 20 16C20 13.24 17.76 11 15 11ZM12 16C12 17.65 13.35 19 15 19C16.65 19 18 17.65 18 16C18 14.35 16.65 13 15 13C13.35 13 12 14.35 12 16Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11837_2934",
    x1: 30,
    y1: 15,
    x2: -4.49871e-8,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#192A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2364A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11837_2934",
    x1: 24,
    y1: 12,
    x2: -3.59897e-8,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#192A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2364A4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseVideoVerificationIcon);
export default __webpack_public_path__ + "static/media/choose-video-verification-icon.720bf4aaae376cc20a023ded352cf9c0.svg";
export { ForwardRef as ReactComponent };